import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, Stack } from '@mui/material';
import ReplyIcon from '@mui/icons-material/Reply';
import image from '../Icon/Teach.png';

const API_URL = process.env.REACT_APP_API_URL;

const ShareButton = ({
  postUrl,
  post = {
    title: 'Check out this post!',
    description: 'Discover useful insights in this article.',
    image: image
  }
}) => {
  const [shortUrl, setShortUrl] = useState('');
  const [loadingShortUrl, setLoadingShortUrl] = useState(false);

  useEffect(() => {
    const generateShortUrl = async () => {
      if (shortUrl || loadingShortUrl) return;

      setLoadingShortUrl(true);
      try {
        const url = new URL(postUrl);
        const pathParts = url.pathname.split('/').filter(Boolean);

        if (pathParts.length < 3) throw new Error('Invalid URL format');

        const [share, type, id] = pathParts;

        const response = await axios.post(`${API_URL}/api/shorten/`, { id });
        const data = response.data;
        const shortId = data.short_id || data.short_code;

        if (!shortId) throw new Error('Invalid short ID from backend');

        const newShortUrl = `${url.origin}/share/${type}/${shortId}`;
        setShortUrl(newShortUrl);
      } catch (error) {
        console.error('Short URL generation failed:', error);
        setShortUrl(postUrl); // fallback to original
      } finally {
        setLoadingShortUrl(false);
      }
    };

    generateShortUrl();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleShareClick = async () => {
    const urlToShare = shortUrl || postUrl;

    if (navigator.share) {
      try {
        await navigator.share({
          title: post.title,
          text: post.description,
          url: urlToShare,
        });
      } catch (error) {
        console.error('Error using browser share:', error);
      }
    } else {
      alert('Sharing is not supported on this browser.');
    }
  };

  return (
    <Link
      component="button"
      onClick={handleShareClick}
      sx={{
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        zIndex: 9999,
        padding: '10px',
        borderRadius: '50%',
        '&:hover': {
          color: '#00bfff',
          transform: 'scale(1.2)',
        },
        '@media (max-width: 600px)': {
          padding: '8px',
        },
      }}
      aria-label="Share"
    >
      <Stack direction="row" alignItems="center" spacing={1}>
        <ReplyIcon sx={{ fontSize: '2rem', color: '#fff', transform: 'scaleX(-1)' }} />
      </Stack>
    </Link>
  );
};

export default ShareButton;
